import { Component, computed, inject, input } from '@angular/core';
import { NgIconComponent, provideIcons, provideNgIconLoader, withCaching } from '@ng-icons/core';
import { heroSpeakerWave } from '@ng-icons/heroicons/outline';
import { heroStopSolid } from '@ng-icons/heroicons/solid';
import { HttpClient } from '@angular/common/http';

export type IconSize = 'giant' | 'large' | 'medium' | 'small' | 'none';

@Component({
  selector: 'app-icon',
  standalone: true,
  imports: [NgIconComponent],
  providers: [
    provideIcons({ heroSpeakerWave, heroStopSolid }),
    provideNgIconLoader((name) => {
      const http = inject(HttpClient);
      return http.get(`/assets/icons/${name}.svg`, { responseType: 'text' });
    }, withCaching()),
  ],
  templateUrl: './icon.component.html',
  styleUrl: './icon.component.scss',
  host: {
    '[class]': "'inline-flex ' + iconSize()",
  },
})
export class IconComponent {
  name = input.required<string>();
  size = input<IconSize>('large');
  color = input<string>();
  iconSize = computed(() => {
    const iconSizes: { [key in IconSize]: string } = {
      giant: 'text-[32px]',
      large: 'text-2xl',
      medium: 'text-lg',
      small: 'text-md',
      none: 'none-size',
    };
    return iconSizes[this.size()];
  });
}
